import styles from '../cssModules/index.module.css';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Form } from 'react-bootstrap';


export function HandBagTemplate({ loginStatus, prodInfo, setProdInfo }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    useEffect(() => {
        setProdInfo(prev => {
            return ({ ...prev, 'additionsize': {} })
        })
    }, [setProdInfo]);

    const outMaterial = ['Leather', 'Polyester', 'Nylon', 'ABS', 'Canvas',
        'Fabric', 'Felt', 'Metal', 'Polycarbonate', 'Polypropylene',
        'Synthetic'
    ];

    const userSegment = ['Men', 'Women'];

    const width = [
        'Small (Up to 19 cm)',
        'Medium (20 - 39 cm)',
        'Large (40 cm & more)'
    ];

    const capacity = [
        'Up to 1 L',
        '1.0 to 1.9 L',
        '2.0 to 2.9 L'
    ];

    const occasion = [
        'Business',
        'Casual',
        'Evening',
        'Welding'
    ];

    const specialFeature = [
        'Lightweight',
        'Cell Phone Holder',
        'Water Resistant',
        'Anti-Theft',
        'Credit Card Slot',
        'Detachable Strap',
        'Laptop Compartment',
        'RFID Blocking',
        'Bottle Holder',
        'Checkpoint Friendly',
        'Drop Bottom',
        'Expandable',
        'Fade Resistant',
        'Foldable',
        'Locking',
        'Shoe Compartment',
        'Stain Resistant',
        'Tablet Compartment',
        'Trolley Sleeve',
        'Waterproof',
        'None'
    ]

    const itemLength = [
        'Up to 19 cm',
        '20 to 24 cm',
        '25 cm & above'];


    const strapType = [
        'Adjustable',
        'Cross-Body',
        'Hand-Carry',
        'Shoulder',
        'Waist Strap'
    ];

    const waterResistance = [
        'Waterproof', 'Water-Resistant'
    ];

    const liningDesc = [
        'Polyester',
        'Faux Leather',
        'Cotton',
        'Leather',
        'Acrylic',
        'Faux Fur',
        'Faux Suede',
        'Linen',
        'Nylon',
        'Plastic',
        'Polycotton',
        'Polyurethane',
        'Polyvinyl Chloride',
        'Rayon',
        'Silk',
        'Suede',
        'Vinyl'
    ];

    const color = ['red', 'darkred', 'tan', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const design = [
        'Solid',
        'Floral',
        'Geometric',
        'Abstract',
        'Animal Print',
        'Argyle',
        'Camouflage',
        'Checkered',
        'Chevron',
        'Gingham',
        'Hearts',
        'Herringbone',
        'Houndstooth',
        'Ikat',
        'Letter Print',
        'Marble',
        'Moire',
        'Paisley',
        'Plaid',
        'Polka Dots',
        'Quilted',
        'Star',
        'String',
        'Striped',
        'Tie-Dye',
    ];

    const embfeature = [
        'Logo',
        'Tassel',
        'Embroidery',
        'Applique',
        'Bead',
        'Bow',
        'Button',
        'Crystal',
        'Fringe',
        'Glitter',
        'Lace',
        'Pearl',
        'Rhinestone',
        'Sequin',
        'Stud',
        'None'
    ];

    const style = [
        'Western',
        'Utility',
        'Contemporary',
        'Bohemian',
        'Deconstructed',
        'Formal',
        'Minimal',
        'Retro'
    ];

    const closureType = ['Zipper',
        'Magnetic',
        'Flap',
        'Buckle',
        'Button',
        'Clasp',
        'Drawstring',
        'Hook and Loop',
        'Kiss Lock',
        'Push Lock',
        'Snap',
        'Twist Lock'
    ];

    const includedComponent = [
        'Sling Bag',
        'Clutch',
        'Messenger Bag',
        'Crossbody Bag',
        'Card Holder',
        'Cosmetic Bag',
        'Keychain',
        'Shoulder Strap',
        'Wallet',
        'Wristlet',
        'None'
    ];

    const itemHeight = [
        'Up to 9 cm',
        '10 to 14 cm',
        '15 to 24 cm',
        '25 to 29 cm',
        '30 cm & above'
    ];

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)'];

    const stock = ['In stock', 'Out of stock'];

    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 500000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });
            formData.append('product', JSON.stringify(prodInfo));

            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        let data = await response.json();
                        let prodId = data['prodId'];
                        alert('Product has been listed successfully!');
                        navigate(`/repeat/${prodInfo.prod}/${prodId}`);
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prodinfo = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prodInfo['additionsize'], [size]: Number(stock) };
                setProdInfo(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prodInfo['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prodInfo['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prodInfo["additionsize"], [size]: null }
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prodInfo.additionsize && (
                <div className={`${styles.sellerUploadmainDiv}`}>
                    <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                        <div className={`${styles.sellerUploadDiv}`}>
                            <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph1'>
                                        Choose photo 1
                                    </label>
                                    <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph2'>
                                        Choose photo 2
                                    </label>
                                    <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph3'>
                                        Choose photo 3
                                    </label>
                                    <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph4'>
                                        Choose photo 4
                                    </label>
                                    <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph5'>
                                        Choose photo 5
                                    </label>
                                    <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                                </div>
                            </div>

                            <div className={`${styles.selleruploadFormDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='outMaterial'>
                                        Outer Material Type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='outMaterial' required name='outMaterial' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {outMaterial.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='itemLength'>
                                        Item length
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='itemLength' required name='itemLength' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {itemLength.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='width'>
                                        Width
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='width' name='width' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {width.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='capacity'>
                                        Capacity
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='capacity' name='capacity' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {capacity.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='occasion'>
                                        Occasion
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='occasion' required name='occasion' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {occasion.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='specialFeature'>
                                        Special Feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='specialFeature' required name='specialFeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {specialFeature.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='strapType'>
                                        Strap Type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='strapType' required name='strapType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {strapType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' required name='closureType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='waterResistance'>
                                        Water Resistance
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='waterResistance' required name='waterResistance' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {waterResistance.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='liningDesc'>
                                        Lining Description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='liningDesc' required name='liningDesc' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {liningDesc.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='includedComponent'>
                                        Included Component
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='includedComponent' required name='includedComponent' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {includedComponent.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='embfeature'>
                                        Embellishment Feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='embfeature' required name='embfeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {embfeature.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='style'>
                                        Style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='style' required name='style' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {style.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='itemHeight'>
                                        Item Height
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='itemHeight' required name='itemHeight' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {itemHeight.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='design'>
                                        Design
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='user'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='user' name='userSegment' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value='' selected disabled hidden></option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='name'
                                        onBlur={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true}
                                        type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='price'
                                        onBlur={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true}
                                        type='number' placeholder="price" name='oldPrice' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='discountP'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='discountP'
                                        onBlur={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true}
                                        type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock' onBlur={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='number' placeholder="Total stock available" name='stock' />
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Item length</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {itemLength.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prodInfo['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prodInfo['additionsize'][option] ? prodInfo['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' onBlur={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                                </div>
                            </div>
                        </div>
                        <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                        <button className={`${styles.uploadRepeat}`}
                            onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                    </form >
                </div >
            )}
        </>
    )
}